/**
 * Transform annual performance data from API format to table format
 * Converts { year, jan, feb, ..., twr, sharpe, ... } to { year, months: {}, metrics: {} }
 */
export const transformAnnualPerformanceData = (apiResponse) => {
  if (!apiResponse || !apiResponse.strategyDetail) {
    return [];
  }

  return apiResponse.strategyDetail.map((item) => ({
    year: item.year,
    months: {
      jan: item.jan,
      feb: item.feb,
      mar: item.mar,
      apr: item.apr,
      may: item.may,
      jun: item.jun,
      jul: item.jul,
      aug: item.aug,
      sep: item.sep,
      oct: item.oct,
      nov: item.nov,
      dec: item.dec
    },
    metrics: {
      twr: item.twr,
      sharpe: item.sharpe,
      sortino: item.sortino,
      largest_drawdown: item.largestDrawdown
    }
  }));
};
